require('./init/init');
require('./lazy-loading-images/lazy-loading-images');

require('./blocks/welcome-button/welcome-button');
// require('./Def/def-goToTop/def-goToTop');
// require('./def/def-validation/def-validation');
require('./def/def-tabs/def-tabs');
require('./blocks/enter/enter');
require('./blocks/footer-menu/footer-menu.js');

window.SearchParams = require('./SearchParams/SearchParams.js').default;
